import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { Home } from "./Home";
import { Login } from "./Login";
import firebase from 'firebase/compat/app';
import { config } from "../config";
import { NewPatientFormGenerator } from "./NewNewPatientFormGenerator";
import { NewPatientFormLink } from "./NewNewPatientFormLink";
import { FileUploadPage } from "./FileUpload";

firebase.initializeApp(config.providers.firebase);

export function SiteRouter() {
  
  return (
    <>
      <Router>
        <Routes>
          <Route path="/file-upload" element={<FileUploadPage />} />
          <Route path="/new-patient-form/:formId" element={<NewPatientFormLink />} />
          <Route path="/new-patient-form" element={<NewPatientFormGenerator />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </>
  )
}